// extracted by mini-css-extract-plugin
export default {"removeButton":"modal-footer_removeButton__7I6yS","backButton":"modal-footer_backButton__Ot5Oz"};